export const USERS_CONSTS = {
    GET_USERS: "GET_USERS",
    GET_USER_BY_ID: 'GET_USER_BY_ID',
    TOGGLE_USER_BLOCK_STATE: 'TOGGLE_USER_BLOCK_STATE',
    CLEAR_USER_BY_ID: 'CLEAR_USER_BY_ID',
};
